/**
 * @generated SignedSource<<cdaeb55f93f39adfe38d96fa71824fd6>>
 * @relayHash ad9e6eaf34525daacc17362653e63272
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad9e6eaf34525daacc17362653e63272

import type { ConcreteRequest } from 'relay-runtime';
export type DeleteProjectV2ItemInput = {
  clientMutationId?: string | null | undefined;
  itemId: string;
  projectId: string;
};
export type updateIssueMutationDeleteProjectMutation$variables = {
  input: DeleteProjectV2ItemInput;
};
export type updateIssueMutationDeleteProjectMutation$data = {
  readonly deleteProjectV2Item: {
    readonly deletedItemId: string | null | undefined;
  } | null | undefined;
};
export type updateIssueMutationDeleteProjectMutation = {
  response: updateIssueMutationDeleteProjectMutation$data;
  variables: updateIssueMutationDeleteProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProjectV2ItemPayload",
    "kind": "LinkedField",
    "name": "deleteProjectV2Item",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedItemId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueMutationDeleteProjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueMutationDeleteProjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ad9e6eaf34525daacc17362653e63272",
    "metadata": {},
    "name": "updateIssueMutationDeleteProjectMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f03ef95aad392077538992e2c84a9752";

export default node;
